module.exports = __webpack_public_path__ + "/build/web/images/testimonials-left-1-2@3x.82be5e6de493ed6fda765537ebcaba35.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-left-1-2@3x.jpg
// module id = 199
// module chunks = 13